export default [
  {
    children: [
      {
        children: [
          {
            component: () =>
              import("pages/ai/AIFeatureConfigurationFormPage.vue"),
            meta: {
              accessLevel: "ai_admin",
              title: "Add AI Feature Configuration",
            },
            name: "ai-feature-configuration-add",
            path: "add",
          },
          {
            component: () =>
              import("pages/ai/AIFeatureConfigurationFormPage.vue"),
            meta: {
              accessLevel: "ai_admin",
              title: "Edit AI Feature Configuration",
            },
            name: "ai-feature-configuration-edit",
            path: "edit/:id",
            props: true,
          },
          {
            component: () => import("pages/ai/AIFeatureConfigurationsPage.vue"),
            meta: {
              accessLevel: "ai_admin",
              title: "AI Feature Configurations",
            },
            name: "ai-feature-configurations",
            path: "",
          },
        ],
        component: () => import("pages/ai/AIFeatureConfigurationBasePage.vue"),
        meta: {
          accessLevel: "ai_admin",
          title: "AI Feature Management",
        },
        path: "feature-configuration",
      },
      {
        component: () => import("pages/ai/AIHomePage.vue"),
        meta: {
          accessLevel: "ai_admin",
          title: "AI",
        },
        name: "ai-home",
        path: "",
      },
      {
        component: () => import("pages/ai/AIVisibilityCompaniesPage.vue"),
        meta: {
          accessLevel: "ai_admin",
          title: "AI Visibility Companies",
        },
        name: "ai-visibility-companies",
        path: "ai-visibility-companies",
      },
      {
        component: () => import("pages/ai/AIVisibilityProjectsPage.vue"),
        meta: {
          accessLevel: "ai_admin",
          title: "AI Visibility Projects",
        },
        name: "ai-visibility-projects",
        path: "ai-visibility-projects",
      },
      {
        component: () => import("pages/ai/AIVisibilityProjectPage.vue"),
        meta: {
          accessLevel: "ai_admin",
          title: "AI Visibility Project",
        },
        name: "ai-visibility-project",
        path: "ai-visibility-projects/:id",
        props: true,
      },
    ],
    component: () => import("pages/ai/AIPage.vue"),
    meta: {
      accessLevel: "ai_admin",
      title: "AI",
    },
    name: "ai",
    path: "ai",
  },
];
